import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Aig from '@assets/images/aig.svg';
import Axa from '@assets/images/axa.svg';
import Chubb from '@assets/images/chubb.svg';
import Gnp from '@assets/images/gnp.svg';
import Hdi from '@assets/images/hdi.svg';
import Mapfre from '@assets/images/mapfre.svg';
import Primero from '@assets/images/primero.svg';
import Qualitas from '@assets/images/qualitas.svg';
import Zurich from '@assets/images/zurich1.svg';

export const InsuranceLogos: React.FC = () => {
  const insurances = [
    Chubb,
    Gnp,
    Primero,
    Aig,
    Hdi,
    Axa,
    Mapfre,
    Zurich,
    Qualitas,
  ];

  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  return (
    <Container
      style={{ padding: 'initial' }}
      maxWidth={!isTablet ? 'lg' : !isMobile ? 'md' : 'sm'}
      sx={{
        height: !isTablet ? '433px' : '550px',
        margin: '80px auto 30px auto',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        maxWidth={!isTablet ? '1180px' : 688}
        height={!isTablet ? 368 : 500}
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          component="h2"
          sx={{
            maxWidth: !isMobile ? '1180px' : '340px',
            height: !isTablet ? '34px' : !isMobile ? '54px' : '72px',
            fontWeight: 700,
            fontSize: !isTablet ? '28px' : !isMobile ? '22px' : '20px',
            lineHeight: !isTablet ? '34px' : !isMobile ? '27px' : '25px',
            textAlign: 'center',
            paddingBottom: '30px',
            margin: isMobile ? 'auto' : 'unset',
          }}
        >
          Somos el broker líder en México porque nos respaldan las mejores
          aseguradoras
        </Typography>
        <Grid
          container
          height={'inherit'}
          columns={{ xs: 10, sm: 15, md: 12 }}
          sx={{
            display: 'flex',
            justifyContent: !isTablet ? 'space-between' : 'space-around',
            alignItems: 'center',
            textAlign: 'center',
            marginTop: !isMobile ? 'unset' : '15px',
          }}
        >
          {insurances.map((insurance, index) => (
            <Grid
              key={index}
              xs={5}
              sm={5}
              md={4}
              height={!isTablet ? 60 : 40}
              marginTop={!isTablet ? '30px' : '5px'}
            >
              <Box
                component={'img'}
                loading='lazy'
                src={insurance}
                height={!isMobile ? 'unset' : '33px'}
                width={!isMobile ? 'unset' : '150px'}
              ></Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};
